import { useState } from "react";
import { Button } from "../../components";
import classes from "./UBI.module.scss";

export default function UBI() {
  const [pressed, setPressed] = useState(false);

  return pressed ? (
    <div className={classes.ubi}>
      <div className={classes.bold}>👍</div>
    </div>
  ) : (
    <div className={classes.ubi}>
      <div className={classes.bold}>Enter your IBAN:</div>
      <input className={classes.input}></input>
      <Button text="Apply" onClick={() => setPressed(true)} />
    </div>
  );
}
